import { apiFetch } from "./baseClient";
import {
  BillingConfig,
  BillingStatus,
  UserInfo,
  SubscriptionStatus,
} from "../model/backendTypes";

export async function renameOrganization(
  userId: number,
  newName: string
): Promise<UserInfo> {
  const resp = await apiFetch("/api/organization/rename", {
    method: "POST",
    body: {
      user_id: userId,
      new_name: newName,
    } as any,
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`renameOrganization failed: ${resp.status} ${text}`);
  }

  return (await resp.json()) as UserInfo;
}

export async function getBillingStatus(): Promise<BillingStatus> {
  const resp = await apiFetch("/api/billing/status", {
    method: "GET",
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`getBillingStatus failed: ${resp.status} ${text}`);
  }

  return (await resp.json()) as BillingStatus;
}

export async function getBillingConfig(): Promise<BillingConfig> {
  const resp = await apiFetch("/api/billing/config", {
    method: "GET",
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`getBillingConfig failed: ${resp.status} ${text}`);
  }

  return (await resp.json()) as BillingConfig;
}

export async function createPortalSession(): Promise<{ portal_url: string }> {
  const resp = await apiFetch("/api/billing/portal", {
    method: "POST",
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`createPortalSession failed: ${resp.status} ${text}`);
  }

  return await resp.json();
}

// dev only
export async function devSetBillingStatus(payload: {
  subscription_status: SubscriptionStatus;
  price_id?: string;
}): Promise<BillingStatus> {
  const resp = await apiFetch("/api/billing/dev/set-status", {
    method: "POST",
    body: payload as any,
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`devSetBillingStatus failed: ${resp.status} ${text}`);
  }

  return (await resp.json()) as BillingStatus;
}